import { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Wrench, ClipboardList } from 'lucide-react';
import LeadForm from './LeadForm';

export default function ContactForms() {
  const [params] = useSearchParams();
  const [tab, setTab] = useState(params.get('form') === 'install' ? 'install' : 'service');

  const tabCls = (active) =>
    `flex flex-1 items-center justify-center gap-2 rounded-xl px-4 py-3.5 font-display text-sm font-bold transition-all sm:text-base ${
      active ? 'bg-brand text-white shadow-md shadow-brand/30' : 'bg-white text-slate-500 border border-slate-200 hover:border-brand hover:text-brand'
    }`;

  return (
    <div data-testid="contact-forms">
      <div className="mb-5 flex gap-3">
        <button onClick={() => setTab('service')} data-testid="form-tab-service" className={tabCls(tab === 'service')} aria-pressed={tab === 'service'}>
          <Wrench className="h-4 w-4" /> Schedule Service
        </button>
        <button onClick={() => setTab('install')} data-testid="form-tab-install" className={tabCls(tab === 'install')} aria-pressed={tab === 'install'}>
          <ClipboardList className="h-4 w-4" /> Free Install Estimate
        </button>
      </div>
      {tab === 'service' ? <LeadForm variant="service" /> : <LeadForm variant="install" />}
    </div>
  );
}
